<template>
  <div
      ref="root"
      class="io-search-form"
      :class="{ 'show': show }"
  >
    <div
        class="io-search-form__background"
        @click="close"
    ></div>
    <div class="container-fluid">
      <SearchForm
          ref="searchFormInput"
          @search="close"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  onMounted,
  onBeforeUnmount,
  computed,
  ref,
  watch,
  nextTick,
} from 'vue';

import { useStore } from 'vuex';
import SearchForm from '@/components/SearchForm/SearchForm.vue';

const store = useStore();
const root = ref<InstanceType<typeof HTMLElement>>();
const searchFormInput = ref<InstanceType<typeof SearchForm>>();

const show = computed(() => store.getters['search/showForm']);

const onClose = () => {
  setTimeout(() => {
    if (!searchFormInput.value) return;

    searchFormInput.value.form.query = null;
  }, 350);
};

const close = () => {
  store.dispatch('search/close');
  onClose();
};

const ifClickedOutside = (event: MouseEvent) => {
  if (searchFormInput.value) {
    const withinBoundaries = event.composedPath().includes(searchFormInput.value.$el);

    if (!withinBoundaries) {
      close();
    }
  }
};

watch(() => show.value, () => {
  if (show.value && root.value) {
    const searchInput: HTMLElement | null = root.value.querySelector('input[type=text]');

    nextTick(() => {
      if (searchInput) {
        searchInput.focus();
      }
    });
  } else if (!show.value) {
    onClose();
  }
});

onMounted(() => {
  if (root.value) {
    root.value.addEventListener('click', ifClickedOutside);
  }
});

onBeforeUnmount(() => {
  if (root.value) {
    root.value.removeEventListener('click', ifClickedOutside);
  }
});
</script>

<style lang="scss">
@import "src/scss/component-helpers";

.io-search-form {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transform: translateY(-100%);
  transform-origin: center;
  opacity: 0;
  transition: opacity .35s ease, transform .475s ease-in-out;
  pointer-events: none;
  z-index: 500;

  &__background {
    background: #293033;
    position: absolute;
    pointer-events: none;
    height: 200%;
    width: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    transition: opacity .475s ease-in-out;

    & + * {
      position: relative;
    }
  }

  > .container-fluid {
    @include header-height;

    .search-form {
      max-width: 840px;
      margin: 40px auto 0;
    }
  }

  &.show {
    transform: translateY(0);
    opacity: 1;
    pointer-events: all;

    .io-search-form__background {
      opacity: .2;
      pointer-events: all;
    }
  }
}
</style>
